import React, { useEffect, useState } from "react";
import SecondaryButton from "../buttons/SecondaryButton.js";

import Modal1 from "../modals/Modal1.js";

import PDF from "../pdf/PDF.js";
import downloadFile from "../api/download/downloadFile.js";
import getTemporaryUrl from "../api/getTemporaryUrl.js";
import SmallSpinner from "../loading/SmallSpinner.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import {
  getDocDataById,
  getDocDataByRef,
  updateDocDataField,
} from "../models/DataFunctions.js";
import { generateKey } from "../portal/InvoiceSign.js";
import PDFModal from "../pdf/PDFModal.js";
import { name } from "dayjs/locale/fr.js";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import { useSnackbar } from "notistack";
import sendAvailableReportsEmail from "../api/send/sendAvailableReportsEmail.js";
import Tippy from "@tippyjs/react";
import { isFolderMaster } from "../hexagone/VisibilityHelpers.js";

const SlotRapportVisualisateur = ({
  folder,
  orgData,
  userData,
  slot_id,
  prefix,
  handleUpdate,
}) => {
  const [open, setOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [loadingFile, setLoadingFile] = useState(false);
  const [slotData, setSlotData] = useState(null);

  const handleLoadUrl = async () => {
    setLoadingFile(true);
    const token = await getOrRefreshFirebaseToken();
    await getTemporaryUrl(token, "rapport-payment", "", folder.id, prefix);
    let folderData = await getDocDataByRef(folder.ref);
    let slotData = await getDocDataById("rapport_slot", slot_id);
    setSlotData(slotData);
    let files = slotData?.files;
    if (files) setFiles(files);
    setLoadingFile(false);
  };

  const handleFetchData = async () => {
    setLoadingFile(true);

    let slotData = await getDocDataById("rapport_slot", slot_id);
    setSlotData(slotData);
    let files = slotData?.files;
    if (files) setFiles(files);
    setLoadingFile(false);
  };

  useEffect(() => {
    handleFetchData();
  }, [slot_id, folder.id, folder.rapport?.slots]);

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const [loadingEmail, setLoadingEmail] = useState(false);

  const handleNotifyAvailableReports = async () => {
    setLoadingEmail(true);
    try {
      const token = await getOrRefreshFirebaseToken();
      await sendAvailableReportsEmail(folder.id, slot_id, token, prefix);
      handleClickVariant("Le client a été notifié avec succès", "success");
    } catch (error) {
      console.error("Error notifying available reports:", error);
      handleClickVariant("Erreur lors de la notification", "error");
    } finally {
      setLoadingEmail(false);
    }
  };

  const [loadingData, setLoadingData] = useState(false);

  const handleDeleteFile = async (file) => {
    let newFiles = files.filter((f) => f.name !== file.name);
    await updateDocDataFieldApi(slotData.ref, "files", newFiles, prefix);
    handleLoadUrl();
    handleUpdate();
  };

  return (
    <div className="flex flex-col gap-2 h-full">
      <PDFModal
        type={"rapport-slot"}
        document={{
          id: "rapport-slot" + "-" + slot_id,
          name: "Rapports_" + folder.nom.replace(" ", "_"),
        }}
        folder={folder}
        onFetch={handleUpdate}
        userData={userData}
        prefix={prefix}
        handleDeleteFile={handleDeleteFile}
        orgData={orgData}
        setLoadingData={setLoadingData}
      >
        <SecondaryButton>
          Voir les rapports
          <SmallSpinner loading={loadingData} margin={0} size={20} />
        </SecondaryButton>
      </PDFModal>
      {isFolderMaster(orgData, folder) && (
        <Tippy
          content={` Notifier le ${folder.client_type === "particulier" ? "particulier" : folder.client_type === "architect" ? "particulier + client" : "client"} que les rapports sont disponibles`}
          delay={500}
          className="custom-tooltip"
        >
          <div>
            <SecondaryButton
              onClick={handleNotifyAvailableReports}
              className={"w-fit"}
              disabled={loadingEmail || slotData?.state !== "unlocked"}
            >
              Envoyer les rapports
              <SmallSpinner loading={loadingEmail} margin={0} size={20} />
            </SecondaryButton>
          </div>
        </Tippy>
      )}
    </div>
  );
};

export default SlotRapportVisualisateur;
